import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanDeactivateGuard } from '../core/services/guards';
import { BillingStepComponent } from './billing-step/billing-step.component';
import { ContactsStepComponent } from './contacts-step/contacts-step.component';
import { InsuranceStepComponent } from './insurance-step/insurance-step.component';
import { OrderWizardComponent } from './order-wizard.component';
import { ProductsStepComponent } from './products-step/products-step.component';
import { ProviderStepComponent } from './provider-step/provider-step.component';
import { SummaryStepComponent } from './summary-step/summary-step.component';

const routes: Routes = [
  {
    path: '',
    component: OrderWizardComponent,
    canDeactivate: [CanDeactivateGuard],
    children: [
      { path: 'insurance', component: InsuranceStepComponent, data: { title: 'Authorize Order' } },
      { path: 'products', component: ProductsStepComponent, data: { title: 'Authorize Order' } },
      { path: 'provider', component: ProviderStepComponent, data: { title: 'Authorize Order' } },
      { path: 'contacts', component: ContactsStepComponent, data: { title: 'Authorize Order' } },
      { path: 'billing', component: BillingStepComponent, data: { title: 'Authorize Order' } },
      { path: 'summary', component: SummaryStepComponent, data: { title: 'Authorize Order' } },
      { path: 'make-payment', component: BillingStepComponent, data: { title: 'Order Confirmation' } },
      { path: '**', redirectTo: 'insurance' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrderWizardRoutingModule {}
